import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import React from 'react';

import { useTopAreaStore } from '../stores/TopAreaStore';

const StyledImage = styled('img')({
  height: '100%',
  left: 0,
  objectFit: 'cover',
  objectPosition: '50% 50%',
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: 1,
});

const imageGenerator = (url: string, w: string, q: string) => {
  const baseUrl = new URL(url);
  baseUrl.searchParams.set('w', w);
  baseUrl.searchParams.set('imageFormat', 'Jpeg');
  baseUrl.searchParams.set('q', q);

  return baseUrl.toString();
};

export const BannerImage: FC = () => {
  const { getTestId } = useTestId();

  // HOTFIX: Article pages overwrite
  const imgSizesProp = document.querySelector('.article-page') ? '(max-width: 1024px) 100vw, 984px' : '100vw';

  const { backgroundImageUrl, bannerHeadlineText } = useTopAreaStore();

  if (!backgroundImageUrl) {
    return null;
  }

  return (
    <StyledImage
      alt={bannerHeadlineText}
      data-testid={getTestId('img')}
      sizes={imgSizesProp}
      src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      srcSet={`
    ${imageGenerator(backgroundImageUrl, '640', '50')} 640w,
    ${imageGenerator(backgroundImageUrl, '767', '50')} 767w,
    ${imageGenerator(backgroundImageUrl, '1024', '90')} 1024w,
    ${imageGenerator(backgroundImageUrl, '1440', '80')} 1366w,
    ${imageGenerator(backgroundImageUrl, '1536', '50')} 1536w,
    ${imageGenerator(backgroundImageUrl, '1920', '50')} 1920w,
    ${imageGenerator(backgroundImageUrl, '2732', '50')} 2732w
    `}
    />
  );
};
